import lockr from 'lockr';
import axios from 'axios';

export default class AuthService {
    setUser(data) {
        lockr.set('user', data)

        return this;
    }

    setToken(data) {
        lockr.set('token', data)

        return this;
    }

    setRefresh(data) {
        lockr.set('refresh', data)

        return this;
    }

    getUser() {
        return lockr.get('user', false);
    }

    isAdminRole() {
        const user = this.getUser()

        try {
            if (user.is_superuser) {
                return true;
            }

        } catch (e) {
            return false;
        }
    }

    getToken() {
        return lockr.get('token', false);
    }

    getRefresh() {
        return lockr.get('refresh', false);
    }

    isLoggedIn() {
        return this.getToken();
    }

    refresh(success, error) {
        axios.post('/auth/refresh')
            .then(success)
            .catch(error);
    }

    logOut() {
        lockr.rm('user');
        lockr.rm('token');
        lockr.rm('refresh');
    }
}
